import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { NewPermalinkSVG } from 'src/components/Icons/Basic'

export const ChatPanelContainerWithArtifact = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
`

export const ChatPanelContainer = styled.div<{
  $isArtifactPanelOpen?: boolean
}>`
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  flex-grow: 1;
  overflow-x: hidden;

  ${({ $isArtifactPanelOpen }) =>
    $isArtifactPanelOpen &&
    `
    width: 35%;
  `}
  height: calc(100vh - 60px);
`

export const ChatHeader = styled.div<{
  $isArtifactPanelOpen?: boolean
  $isAgentChat?: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 32px 40px 0 40px;

  ${({ $isAgentChat, $isArtifactPanelOpen }) =>
    $isAgentChat &&
    !$isArtifactPanelOpen &&
    `
    position: sticky;
    backround: transparent;
  `}

  ${({ $isArtifactPanelOpen }) =>
    $isArtifactPanelOpen &&
    `
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  `}

  ${({ $isAgentChat }) =>
    $isAgentChat &&
    `
    padding-bottom: 8px;
  `}
`

export const ChatTitle = styled.p`
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
  color: ${palette.neutral.black};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 40px;
`

export const ChatPrivateSelector = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
  font-size: 14px;
  color: ${palette.neutral[900]};
`

export const ChatPermalinkSVG = styled(NewPermalinkSVG)`
  cursor: pointer;
  &:hover {
    path {
      fill: ${palette.neutral[200]};
    }
  }
`
